<template>
  <div class="fadein">
    <div class="h30"></div>

    <div class="center1200 bg-white" style="position:relative;">
        <div class="h20"></div>
        <div class="center-title" >
          <span><img class="title-pic" src="/static/img/title-left.png" alt=""> 发布话题 <img class="title-pic" src="/static/img/title-right.png" alt=""></span>
          <el-breadcrumb separator="/" style="position:absolute;left:30px;top:30px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/forum' }"
              >论坛</el-breadcrumb-item
            >
            <el-breadcrumb-item>发布话题</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- <span  @click="goback" style=" cursor: pointer;position:absolute;left:30px;">返回</span> -->
        </div>
        <!-- <div class="h20"></div> -->
        <div v-if="get_user_info.level==null" style="padding:20px;text-align: center;">
            <span>登录后才能发布发布话题哈(￣▽￣")~</span><br><br>
            <div>
              <router-link to="/login">
              <el-button type="primary">请先登录</el-button>
              </router-link>
            </div>
        </div>
        <div style="padding:20px;" v-else>
          标题：<el-input v-model="form.title" autocomplete="off" placeholder="标题" style="width:1110px;"  ></el-input>
          <div class="h20"></div>
          描述：<el-input v-model="form.desn" autocomplete="off" placeholder="描述" style="width:1110px;" ></el-input>
          <div class="h20"></div>
          该话题是： <el-radio v-model="form.is_checkbox" label="0">单选</el-radio>
                          <el-radio v-model="form.is_checkbox" label="1">多选</el-radio>
          <div class="h20"></div>
          选项管理（至少2个选项）：
          <div class="h20"></div>
          <!-- <div style="padding-left: 20px;">

            <el-input placeholder="请输入内容" v-model="input" class="options">
              <template slot="prepend">选项1</template>
            </el-input>
            <div class="h10"></div>
            <el-input placeholder="请输入内容" v-model="input" class="options">
              <template slot="prepend">选项2</template>
            </el-input>
            <el-button type="primary" style="width:120px;" @click="createForum()">发 布</el-button>

          </div> -->


          <el-tag
            :key="tag"
            v-for="tag in form.options"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加新选项</el-button>

          <div class="h20"></div>
          <div style="text-align:center;">
            <el-button type="primary" style="width:120px;" @click="createTopic()">发 布</el-button>

          </div>
        </div>

    </div>

    <div class="h30"></div>
    <Goback></Goback>

</div>

  </template>

  <script>
    import Goback from '@/components/components/goback'
    export default {

components:{
            Goback,

        },
      data() {
        return {
          tid:0,
          form:{
            user_id:localStorage.getItem('token'),
            title:'',
            desn:'',
            is_checkbox:'0',
            options: [],
          },
          inputVisible: false,
          inputValue: '',
          get_user_info:{
            level:null
          },
          loading:0,
        }
      },
      watch:{
        $route(newVal,oldVal){
          if(newVal.name == 'topicdetail'){
            this.$parent.activeIndex = '4'
            this.getUserinfo()
          }
        }
      },
      mounted(){
        this.$parent.activeIndex = '4'
        this.getUserinfo()

      },
      methods:{
        createTopic(){
          if(this.form.title == ''){
            this.$message({
                showClose:true,
                message:"标题不能为空呀~",
                type:"error"
            })
            return false;
          }
          if(this.form.desn == ''){
            this.$message({
                showClose:true,
                message:"描述不能为空呀~",
                type:"error"
            })
            return false;
          }
          if(this.form.options.length<2){
            this.$message({
                showClose:true,
                message:"最少添加2个选项呀~ Σ( ° △ °|||)︴",
                type:"error"
            })
            return false;
          }
          this.openFullScreen();
          // console.log(this.form)
          $.ajax({
            url:"//"+ this.$API_URL +"/api/v1/votes",
            type:"post",
            data:this.form,
            success:(ret)=>{
              // console.log(ret)
              if(ret.code==201){
                this.$message({
                    showClose:true,
                    message:"话题发布成功~",
                    type:"success"
                })
                this.form={
                  user_id:localStorage.getItem('token'),
                  title:'',
                  desn:'',
                  is_checkbox:'0',
                  options: [],
                }
                this.loading = 1
                this.openFullScreen();

                this.$router.push('/forum').catch(err => {err});
              }
            }
          })
        },

        //标签的添加与管理 Start
        handleClose(tag) {
          this.form.options.splice(this.form.options.indexOf(tag), 1);
        },

        showInput() {
          this.inputVisible = true;
          this.$nextTick(_ => {
            this.$refs.saveTagInput.$refs.input.focus();
          });
        },


        getUserinfo(){
          if(localStorage.getItem('token')==null){
              return false;
          }
          $.ajax({
              url:"//"+ this.$API_URL +"/api/v1/user_info/"+localStorage.getItem('token'),
              type:"get",
              success:(ret)=>{

                  this.get_user_info = ret.data
              }
          })
        },

        handleInputConfirm() {
          let inputValue = this.inputValue;
          if (inputValue) {
            this.form.options.push(inputValue);
          }
          this.inputVisible = false;
          this.inputValue = '';
        },
        //标签的添加与管理 End

        goback(){
          this.$router.go(-1);
        },
        //页面加载中
        openFullScreen() {
          const loading = this.$loading({
          lock: true,
          text: "页面加载中（￣口￣）。。。",
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
          });
          // setTimeout(() => {
          if(this.loading==1){
            loading.close();
          }
          // }, 2000);
        },

      }
    }

  </script>

<style scoped>
.options{
  width:400px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/index/createtopic.vue